import gql from 'graphql-tag';
export default gql`
  mutation resetPassword($email: String!, $hash: String!, $password: String!) {
    resetPassword(email: $email, hash: $hash, password: $password)
  }
`;
